<!--
	START DECISIONS
-->
<div class="members-group-container" [ngClass]="{'_requiered':group._requiered, '_collapsed': group.collapsed}" [id]="'mg_' + group._id" *ngIf="group.singleSelection">
	<div class="_group-container-header">
		<div class="title ">
			<span>{{group.name}}</span>
			<small *ngIf="group._requiered">{{'GROUP_VALIDATION.select_one' | translate}}</small>
		</div>
		<mat-icon class="collapsicon-caret" (mousedown)="collapseGroup(group)">keyboard_arrow_up</mat-icon>
	</div>

	<div class="_group-container-body" [ngSwitch]="group.memberDisplay">
		<p class="_group-container-body-description" *ngIf="group.description"><i>{{group.description}}</i></p>

		<div *ngSwitchCase="'horizontal'" class="mod-cards-container" [ngClass]="{'_requiered':group._requiered}">
			<ng-container *ngFor="let mod of group.modifiers">
				<div class="mod-card-single" [ngClass]="{'active':mod._selected}" (mousedown)="addMGroupSingle(group, mod)">
					<div class="card-member-h-img" *ngIf="group.showMemberImages" [ngStyle]="group.cardStyle" [appBgImage]="mod.imageURL" [defaultImage]="appService.images.meal_alt" [model]="mod"></div>
					<div class="_content">
						<div class="_header">
							<mat-icon class="_check">{{ mod._selected ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
							<div class="_title">
								{{mod.name}}
								<div *ngIf="group.showItemDescription && mod._item?.description" style="font-size:16px; ">
									{{mod._item.description}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
		<div *ngSwitchDefault class="mod-cards-container" [ngClass]="{'_requiered':group._requiered}">
			<ng-container *ngFor="let mod of group.modifiers">
				<div class="mod-card-pill" [ngClass]="{'active':mod._selected}" (click)="addMGroupSingle(group, mod)">
					<!--<div class="card-img-top dark-theme" *ngIf="group.showMemberImages" [ngStyle]="group.cardStyle" [appBgImage]="mod.imageURL" [defaultImage]="appService.images.meal_alt" [model]="item"></div>-->
					<div class="card-pill-body">
						<div class="_title">{{mod.name}}</div>
						<div class="_description" *ngIf="group.showItemDescription && mod._item?.description">
							{{mod._item.description}}
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
<!--
	END DECISIONS
-->
<!--
	START MODIFIER GROUPS
-->
<div class="members-group-container" [ngClass]="{'_requiered':group._requiered, '_collapsed': group.collapsed}" [id]="'mg_' + group._id" *ngIf="(group.modifiers | filterBy:{compulsory: false}).length">
	<div class="_group-container-header">
		<div class="title ">
			<span>{{group.name}}</span>
			<small *ngIf="group._requiered">{{group._requieredMessage}}</small>
		</div>
		<mat-icon class="collapsicon-caret" (mousedown)="collapseGroup(group)">keyboard_arrow_up</mat-icon>
	</div>

	<div class="_group-container-body" [ngSwitch]="group.memberDisplay">
		<p class="_group-container-body-description" *ngIf="group.description"><i>{{group.description}}</i></p>
		<!--<ng-container *ngSwitchCase="'horizontal'">-->
		<div *ngIf="group._hasBoth">
			<div class="mod-cards-container">
				<ng-container *ngFor="let item of group.modifiers | filterBy:{$isDefault:true, compulsory: false}">
					<ng-container *ngTemplateOutlet="horizontalModGroupMemberTemplate; context: {item:item, group:group, isSingleSelection:group.memberSelection == 'single'}"></ng-container>
				</ng-container>
				<ng-container *ngFor="let item of group.modifiers | filterBy:{$isDefault:false, compulsory: false}">
					<ng-container *ngTemplateOutlet="horizontalModGroupMemberTemplate; context: {item:item, group:group, isSingleSelection:true}"></ng-container>
				</ng-container>
			</div>
		</div>
		<div class="mod-cards-container" [ngClass]="{'_requiered':group._requiered}" *ngIf="!group._hasBoth">
			<ng-container *ngFor="let item of group.modifiers | filterBy:{compulsory: false}">
				<ng-container *ngTemplateOutlet="horizontalModGroupMemberTemplate; context: {item:item, group:group, isSingleSelection:group.memberSelection == 'single' || item.defaultFormationUnit != null}"></ng-container>
			</ng-container>
		</div>
		<!--</ng-container>-->
		<!--<ng-container *ngSwitchDefault>
			<div *ngIf="group._hasBoth">

				<div class="members-deck">
					<ng-container *ngFor="let item of group.modifiers | filterBy:{$isDefault:true, compulsory: false}">
						<ng-container *ngTemplateOutlet="modGroupMemberTemplate; context: {item:item, group:group, isSingleSelection:group.memberSelection == 'single'}"></ng-container>
					</ng-container>
					<ng-container *ngFor="let item of group.modifiers | filterBy:{$isDefault:false, compulsory: false}">
						<ng-container *ngTemplateOutlet="modGroupMemberTemplate; context: {item:item, group:group, isSingleSelection:true}"></ng-container>
					</ng-container>
				</div>
			</div>
			<div class="members-deck" [ngClass]="{'_requiered':group._requiered}" *ngIf="!group._hasBoth">
				<ng-container *ngFor="let item of group.modifiers | filterBy:{compulsory: false}">
					<ng-container *ngTemplateOutlet="modGroupMemberTemplate; context: {item:item, group:group, isSingleSelection:group.memberSelection == 'single' || item.defaultFormationUnit != null}"></ng-container>
				</ng-container>
			</div>
		</ng-container>-->
	</div>
</div>
<!--
	END MODIFIER GROUPS
-->
<!--START HORIZONTAL MEMBER DISPLAY-->
<ng-template #horizontalModGroupMemberTemplate let-group="group" let-item="item" let-isSingleSelection="isSingleSelection">
	<ng-container *ngIf="isSingleSelection">
		@if(item.defaultFormationUnit && !group.max && !group.min && !item.price && !item._enableEdit) {
			<div class="mod-card-single"
				 [ngClass]="{'active':!item.formationUnit}"
				 (mousedown)="toggleMGroupMulti(group, item, currentItem.formation[0])">
				<div class="card-member-h-img" *ngIf="group.showMemberImages" [ngStyle]="group.cardStyle" [appBgImage]="item.imageURL" [defaultImage]="appService.images.meal_alt" [model]="item"></div>
				<div class="_content">
					<div class="_header">
						<mat-icon class="_check">{{ item.formationUnit ? 'radio_button_unchecked' : 'radio_button_checked'}}</mat-icon>
						<div class="_title">
							{{'without' | translate}}&nbsp;{{item.name || 'missing'}}
							<div class="_description" *ngIf="group.showItemDescription && item._item?.description" style="font-size:16px; ">
								{{item._item.description}}
							</div>
						</div>
						<div class="_price">
						<span *ngIf="item.price > 0">
							+{{item.price | lcurrency}}
						</span>
						</div>
					</div>
				</div>
			</div>
		} @else {
			<div class="mod-card-single"
				 [ngClass]="{'active':item.formationUnit}"
				 (mousedown)="toggleMGroupMulti(group, item, currentItem.formation[0])">
				<div class="card-member-h-img" *ngIf="group.showMemberImages" [ngStyle]="group.cardStyle" [appBgImage]="item.imageURL" [defaultImage]="appService.images.meal_alt" [model]="item"></div>
				<div class="_content">
					<div class="_header">
						<mat-icon class="_check">{{ item.formationUnit ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
						<div class="_title">
							{{item.name || 'missing'}}
							@if (item.formationUnit && item._enableEdit && item._item?.summary) {
								<div class="_summary text-modification">
									{{item._item.summary.text}}
								</div>
							} @else if (group.showItemDescription && item._item?.description) {
								<div class="_description">
									{{item._item.description}}
								</div>
							}
						</div>
						<div class="_price">
						<span *ngIf="item.price > 0">
							+{{item.price | lcurrency}}
						</span>
						</div>
						<button class="_edit" type="button" *ngIf="item._enableEdit" (mousedown)="editItemGroupItem(group, item, $event)">
							<mat-icon svgIcon="edit"></mat-icon>
						</button>
					</div>
				</div>
			</div>
		}
	</ng-container>

	<ng-container *ngIf="!isSingleSelection">
		<ng-container *ngTemplateOutlet="modMultiSelection; context: {item:item, group:group}"></ng-container>
	</ng-container>
</ng-template>
<!--END HORIZONTAL MEMBER DISPLAY-->

<ng-template #modMultiSelection let-group="group" let-item="item">
	<div class="mod-card-multi"
		 (mousedown)="addRemoveMGroupMultiStart(group, item, currentItem.formation[0], true, $event)"
		 [ngClass]="{'active':item.formationUnit}">
		<div class="card-member-h-img" *ngIf="group.showMemberImages" [ngStyle]="group.cardStyle" [appBgImage]="item.imageURL" [defaultImage]="appService.images.meal_alt" [model]="item"></div>
		<div class="_content">
			<div class="_header">
				<mat-icon class="_check">{{ item.formationUnit ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
				<div class="_title">
					{{item.name || 'missing'}}
					<div class="_description" *ngIf="group.showItemDescription && item._item?.description">
						{{item._item.description}}
					</div>
				</div>
				<div class="_price">
					<span *ngIf="item.price > 0">
						+{{item.price | lcurrency}}
					</span>
				</div>

				<div class="_actions" *ngIf="group.memberSelection == 'multi' && item.formationUnit">
					<button type="button" (mousedown)="addRemoveMGroupMulti(group, item, currentItem.formation[0], false, $event)" [disabled]="!item.formationUnit">
						<mat-icon svgIcon="minus_circle"></mat-icon>
					</button>
					<div class="_quantity">
						{{item.count || '0'}}
					</div>
					<button type="button" (mousedown)="addRemoveMGroupMulti(group, item, currentItem.formation[0], true, $event)">
						<mat-icon svgIcon="plus_circle"></mat-icon>
					</button>
 					@if (item._enableEdit) {
						<button class="_edit" type="button" (mousedown)="editItemGroupItem(group, item, $event)">
							<mat-icon svgIcon="edit"></mat-icon>
						</button>
					}
				</div>

			</div>
		</div>
	</div>
</ng-template>


